import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import clsx from 'clsx';
import FilterListIcon from '@material-ui/icons/FilterList';
import { useStyles, useToolbarStyles } from './LogTableStyles';
import Box from '@material-ui/core/Box';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControl from '@material-ui/core/FormControl';
import moment from 'moment';
import StatusBullet from '../../../../components/StatusBullet';
import VisibilityIcon from '@material-ui/icons/Visibility';


function LogTable(props) {
  const { logs } = props;
  const classes = useStyles();


  const CabecalhoTabelaLogUsuarios = props => {
    const classes = useToolbarStyles();

    return (
      <Toolbar
        className={clsx(classes.root)}
      >
        <Typography className={classes.title} variant="h4" id="tableTitle">
          LOGS de usuários no sistema
        </Typography>
      </Toolbar>
    );
  };

  return (
    <Paper className={classes.root}>
      <CabecalhoTabelaLogUsuarios numSelected={0} />
      <TableContainer className={classes.containerTable}>
        <Table
          stickyHeader
          aria-label="sticky table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={'label_usuario'}
                align={'left'}
              >
                {'Usuário'}
              </TableCell>
              <TableCell
                key={'label_email_usuario'}
                align={'left'}
              >
                {'Email'}
              </TableCell>
              <TableCell
                key={'label_log_rotina'}
                align={'left'}
              >
                {'Rotina'}
              </TableCell>
              <TableCell
                key={'label_'}
                align={'left'}
              >
                {'Data'}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {logs.map((item, index) => {
              return (
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={item.idLog}
                >
                  <TableCell
                    align={'left'}
                  >
                    {item.usuario.nomeFantasia}
                  </TableCell>
                  <TableCell
                    align={'left'}
                  >
                    {item.usuario.email}
                  </TableCell>
                  <TableCell
                    align={'left'}
                  >
                    {item.logRotina.descricao}
                  </TableCell>
                  <TableCell
                    align={'left'}
                  >
                    {moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss')}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default LogTable;
